import _ from 'lodash';
import update from 'react-addons-update'; // https://facebook.github.io/react/docs/update.html

export default function widgets(state = {}, action) {
    switch (action.type) {
    case 'SET_ACTIVE_WIDGET':
        return { ...state, activeWidget: action.id };
    case 'ADD_WIDGET':
        return update(state, {
            list: { $push: [action.id] },
            byId: { $merge: {
                [action.id]: {
                    ...state.template[action.widgetTemplateId],
                    id: action.id,
                } } },
        });

    case 'DELETE_WIDGET':
        return { ...state,
            list: _.without(state.list, action.id),
            byId: _.omit(state.byId, action.id),
        };

    // TEXT WIDGETS
    case 'SET_TEXT_WIDGET_VALUE':
        return update(state, {
            byId: {
                [action.id]: {
                    value: { $set: action.value },
                },
            },
        });

    // CHOICE WIDGETS
    case 'SET_CHOICE_WIDGET_VALUE':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    options: {
                        [action.optionId]: {
                            label: { $set: action.value },
                        },
                    },
                },
            },
        });
    case 'ADD_CHOICE_OPTION': {
        // TODO: refactor calculating new id !
        const optionsList = state.byId[action.widgetId].optionsList;
        const newId = (_.isEmpty(optionsList)) ? 1 : _.max(optionsList) + 1;

        return update(state, {
            byId: {
                [action.widgetId]: {
                    optionsList: { $push: [newId] },
                    options: {
                        $merge: {
                            [newId]: {
                                id: newId,
                                label: 'Type anwser',
                                checked: false,
                            },
                        },
                    },
                },
            },
        });
    }
    case 'DELETE_CHOICE_OPTION':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    optionsList: { $set: _.without(state.byId[action.widgetId].optionsList, action.optionId) },
                    options: { $set: _.omit(state.byId[action.widgetId].options, action.optionId) },
                },
            },
        });

    case 'CHECK_CHOICE_WIDGET': {
        const options = _.mapValues(state.byId[action.widgetId].options, (option) => {
            return (_.includes(action.optionIds, option.id)) ? { ...option, checked: true } : { ...option, checked: false };
        });
        return update(state, {
            byId: {
                [action.widgetId]: {
                    options: { $set: options },
                },
            },
        });
    }
    // INPUT WIDGETS
    case 'SET_INPUT_WIDGET_VALUE':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    value: { $set: action.value },
                },
            },
        });
    case 'SET_INPUT_WIDGET_PLACEHOLDER':
        return update(state, {
            byId: {
                [action.id]: {
                    placeholder: { $set: action.value },
                },
            },
        });
    // DATE WIDGETS
    case 'SET_DATE_WIDGET_VALUE':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    value: { $set: action.value },
                },
            },
        });
    case 'SET_DATE_WIDGET_PLACEHOLDER':
        return update(state, {
            byId: {
                [action.id]: {
                    placeholder: { $set: action.value },
                },
            },
        });
    // RANGE WIDGETS
    case 'SET_RANGE_MULTI':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    multi: { $set: action.value },
                },
            },
        });
    case 'SET_RANGE_SCALE_MIN':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    sMin: { $set: action.value },
                },
            },
        });
    case 'SET_RANGE_SCALE_MAX':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    sMax: { $set: action.value },
                },
            },
        });
    case 'SET_RANGE_DEFAULT_MIN':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    dMin: { $set: action.value },
                },
            },
        });
    case 'SET_RANGE_DEFAULT_MAX':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    dMax: { $set: action.value },
                },
            },
        });
    case 'SET_RANGE_STEP':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    step: { $set: action.value },
                },
            },
        });
    case 'SET_RANGE_USER_VALUES':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    dMin: { $set: action.value.min },
                    dMax: { $set: action.value.max },
                },
            },
        });
    case 'SET_RANGE_SINGLE_VALUE':
        return update(state, {
            byId: {
                [action.widgetId]: {
                    singleValue: { $set: action.value },
                },
            },
        });
    // DEFAULT
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/widgets_reducers.js